// ============================================================================
// EventEmitter - Base class for pub/sub pattern
// ============================================================================
// Provides subscribe/emit functionality for stores and managers.
// Extend this class when you need event emission but not caching.
//
// Usage:
//   class MyStore extends EventEmitter {
//       doSomething() { this.emit('thing:done', data); }
//   }
//   myStore.subscribe('thing:done', callback);
// ============================================================================

class EventEmitter {
    constructor() {
        this.listeners = new Map();
    }

    subscribe(event, callback) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event).add(callback);

        return () => {
            const callbacks = this.listeners.get(event);
            if (callbacks) {
                callbacks.delete(callback);
                if (callbacks.size === 0) {
                    this.listeners.delete(event);
                }
            }
        };
    }

    emit(event, data) {
        const callbacks = this.listeners.get(event);
        if (!callbacks) return;
        for (const callback of callbacks) {
            try {
                callback(data);
            } catch (error) {
                console.error(`[${this.constructor.name}] Listener error:`, error);
            }
        }
    }

    destroy() {
        this.listeners.clear();
    }
}

export { EventEmitter };
